export default __webpack_public_path__ + "static/harvard-medical-school-034ac015843c422be1d404c9c8037b43.jpg";